import React from 'react';
import './noData.scss';
import Button from '@material-ui/core/Button';
import noDataImage from './../../../assets/images/no-data-image.png';
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";

/**
 * NoData component.
 * @param props
 * @returns {*}
 * @constructor
 */
function NoData(props) {
    const { message, buttonText } = props;
    const t = useTranslations();

    function handleTabChange() {
        if (props.handleTabChange) {
            props.handleTabChange(this, 1);
        }
    }

    return (
        <div className="no-data">
            <div className="no-data-banner"></div>
            <div className="no-data-block">
                <div className="no-data-banner"></div>
                <div className="no-data-img">
                    <img src={noDataImage} alt=""/>
                </div>
                <div className="no-data-text">
                    <h4>{message ? message : t('no_data')}</h4>
                    <Button onClick={handleTabChange}>{buttonText ? buttonText : t('all_tests')}</Button>
                </div>
            </div>
        </div>
    );
}

export default NoData;
